import { render } from "./stock-adjustment.vue?vue&type=template&id=1b336e51"
import script from "./stock-adjustment.vue?vue&type=script&lang=js"
export * from "./stock-adjustment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__